import React, { PureComponent } from 'react';
import { ReactTinyLink } from 'react-tiny-link';
import handleViewport from 'react-in-viewport';
import schemify from 'url-schemify';

import config from '../config'
import { corsFree } from 'utils/url';

import IconClose from 'icons/icon-close';

const errors = [];

class UrlPreview extends PureComponent {
    state = {
        hasError: false,
        loading: true
    }

    handleError = e => {
        this.setState({
            hasError: true
        });
    }

    handleLoad = () => {
        this.setState({
            loading: false
        });
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        });
    }

    render() {
        if (!config.ENABLE_URL_PREVIEWS || !this.props.url || this.state.hasError) {
            return null;
        }

        return (
            <div className={'url-preview' + (this.state.loading ? ' loading' : '')}>
                {
                    this.props.isSelf ? (
                        <button className="btn preview-remove" onClick={this.props.onUrlPreviewRemove}>
                            <IconClose />
                        </button>
                    ) : null
                }

                {
                    this.props.inViewport && this.props.url ? (
                        <ReactTinyLink
                            url={schemify(this.props.url)}
                            width={'367px'}
                            maxLine={1}
                            cardSize="large"
                            target="_blank"
                            proxyUrl={corsFree('')}
                            onError={this.handleError}
                            onSuccess={this.handleLoad}
                        />
                    ) : null
                }
            </div>
        )
    }
}

export default handleViewport(UrlPreview)
